import type { components } from '@fluencelabs/vodopad-admin-api'
import { Alert, Empty, Typography } from 'antd'

import { ChartSpin } from '@/components/charts/chartTheme'

import { INTERNAL_PRICING_GROUPS } from '../pricingGroups'
import { CapacityOverview } from './CapacityOverview'
import { ClusterCapacityCard } from './ClusterCapacityCard'

type Capacity = components['schemas']['CapacityResponse']

export function CapacitySection({
  capacity,
  loading,
  error,
  chargedByCluster,
  chargedLabel,
}: {
  capacity?: Capacity
  loading: boolean
  error: boolean
  /** Undefined while charges are not loaded. */
  chargedByCluster?: Map<string, number>
  chargedLabel: string
}) {
  return (
    <>
      <h3 style={{ marginTop: 32 }}>Capacity by cluster</h3>
      <Typography.Paragraph type="secondary">
        Sold: resources of customers. Internal groups (
        {INTERNAL_PRICING_GROUPS.join(', ')}) and platform pods are used by the
        platform. Totals and free come from the last hardware measurement; sold
        and internal from recorded resources. Free is what can still be
        reserved; disks are thin-provisioned, so their physically free space is
        larger and shown separately.
      </Typography.Paragraph>
      {loading && <ChartSpin />}
      {error && (
        <Alert type="error" showIcon message="Failed to load capacity" />
      )}
      {capacity?.clusters.length === 0 && (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No clusters" />
      )}
      {capacity && capacity.clusters.length > 0 && (
        <CapacityOverview clusters={capacity.clusters} />
      )}
      {capacity?.clusters.map((cluster) => (
        <ClusterCapacityCard
          key={cluster.clusterId}
          cluster={cluster}
          chargedLabel={chargedLabel}
          chargedCents={
            chargedByCluster && (chargedByCluster.get(cluster.clusterId) ?? 0)
          }
        />
      ))}
    </>
  )
}
